import { Filter } from '@marketplace-web/catalog/catalog-data'

type ViewFilterEventArgs = {
  filter: Filter
  screen?: string
  searchSessionId: string
  globalSearchSessionId: string | null
  globalCatalogBrowseSessionId?: string | null
  type?: string
  code?: string
}

type ViewFilterEventExtra = {
  filter: Filter
  screen?: string
  search_session_id?: string
  global_search_session_id?: string
  global_catalog_browse_session_id?: string | null
  type?: string
  code?: string
}

export const viewFilterEvent = (args: ViewFilterEventArgs) => {
  const {
    filter,
    screen,
    searchSessionId,
    globalSearchSessionId,
    globalCatalogBrowseSessionId,
    type,
    code,
  } = args
  const extra: ViewFilterEventExtra = {
    filter,
    screen,
  }

  if (searchSessionId) extra.search_session_id = searchSessionId
  if (globalSearchSessionId) extra.global_search_session_id = globalSearchSessionId
  if (globalCatalogBrowseSessionId)
    extra.global_catalog_browse_session_id = globalCatalogBrowseSessionId
  if (type) extra.type = type
  if (code) extra.code = code

  return {
    event: 'user.view_filter',
    extra,
  }
}

type ViewSecondaryNavigationArgs = {
  catalogId: number
  position: number
  facetsCount: number
  searchSessionId: string
  globalSearchSessionId: string | null
  globalCatalogBrowseSessionId: string | null
}

type ViewSecondaryNavigationExtra = {
  catalog_id: number
  position: number
  facets_count: number
  search_session_id: string
  global_search_session_id: string | null
  global_catalog_browse_session_id: string | null
}

export const viewSecondaryNavigationEvent = (args: ViewSecondaryNavigationArgs) => {
  const extra: ViewSecondaryNavigationExtra = {
    catalog_id: args.catalogId,
    position: args.position,
    facets_count: args.facetsCount,
    search_session_id: args.searchSessionId,
    global_search_session_id: args.globalSearchSessionId,
    global_catalog_browse_session_id: args.globalCatalogBrowseSessionId,
  }

  return {
    event: 'user.view_secondary_navigation',
    extra,
  }
}

type ClickSecondaryNavigationArgs = {
  catalogId: number
  position: number
  facetsCount: number
  searchSessionId: string
  globalSearchSessionId: string | null
  globalCatalogBrowseSessionId: string | null
}

type ClickSecondaryNavigationExtra = {
  catalog_id: number
  position: number
  facets_count: number
  search_session_id: string
  global_search_session_id: string | null
  global_catalog_browse_session_id: string | null
}

export const clickSecondaryNavigationEvent = (args: ClickSecondaryNavigationArgs) => {
  const extra: ClickSecondaryNavigationExtra = {
    catalog_id: args.catalogId,
    position: args.position,
    facets_count: args.facetsCount,
    search_session_id: args.searchSessionId,
    global_search_session_id: args.globalSearchSessionId,
    global_catalog_browse_session_id: args.globalCatalogBrowseSessionId,
  }

  return {
    event: 'user.click_secondary_navigation',
    extra,
  }
}

type ViewDynamicFilterEventArgs = {
  id: string | number
  type: string
  code: string
  position: number
  itemsCount?: number | null
  searchText?: string
  filteringSessionId: string | null
  globalSearchSessionId?: string | null
  globalCatalogBrowseSessionId?: string | null
  searchSessionId?: string | null
  fromScreen: string
}

type ViewDynamicFilterEventExtra = {
  id: string | number
  type: string
  code: string
  position: number
  items_count?: number | null
  search_text?: string
  filtering_session_id: string | null
  global_search_session_id?: string | null
  global_catalog_browse_session_id?: string | null
  search_session_id?: string | null
  from_screen: string
}

export const userViewDynamicFilterOptionEvent = (args: ViewDynamicFilterEventArgs) => {
  const {
    id,
    type,
    position,
    itemsCount,
    searchText,
    filteringSessionId,
    searchSessionId,
    globalSearchSessionId,
    globalCatalogBrowseSessionId,
    fromScreen,
  } = args

  const extra: ViewDynamicFilterEventExtra = {
    id,
    position,
    type,
    code: type,
    items_count: itemsCount,
    search_text: searchText,
    filtering_session_id: filteringSessionId,
    from_screen: fromScreen,
  }

  if (searchSessionId) extra.search_session_id = searchSessionId
  if (globalSearchSessionId) extra.global_search_session_id = globalSearchSessionId
  if (globalCatalogBrowseSessionId)
    extra.global_catalog_browse_session_id = globalCatalogBrowseSessionId

  return {
    event: 'user.view_filter_option',
    extra,
  }
}

type ClickDynamicFilterEventArgs = {
  id: string | number
  type: string
  code: string
  position: number
  isSelected: boolean
  itemsCount?: number | null
  searchText?: string
  filteringSessionId: string | null
  globalSearchSessionId?: string | null
  globalCatalogBrowseSessionId?: string | null
  searchSessionId?: string | null
  fromScreen: string
}

type ClickDynamicFilterEventExtra = {
  id: string | number
  type: string
  code: string
  position: number
  is_selected: boolean
  items_count?: number | null
  search_text?: string
  filtering_session_id: string | null
  global_search_session_id?: string | null
  global_catalog_browse_session_id?: string | null
  search_session_id?: string | null
  from_screen: string
}

export const userClickDynamicFilterOptionEvent = (args: ClickDynamicFilterEventArgs) => {
  const {
    id,
    type,
    position,
    isSelected,
    itemsCount,
    searchText,
    filteringSessionId,
    searchSessionId,
    globalSearchSessionId,
    globalCatalogBrowseSessionId,
    fromScreen,
  } = args

  const extra: ClickDynamicFilterEventExtra = {
    id,
    position,
    type,
    code: type,
    is_selected: isSelected,
    items_count: itemsCount,
    search_text: searchText,
    filtering_session_id: filteringSessionId,
    from_screen: fromScreen,
  }

  if (searchSessionId) extra.search_session_id = searchSessionId
  if (globalSearchSessionId) extra.global_search_session_id = globalSearchSessionId
  if (globalCatalogBrowseSessionId)
    extra.global_catalog_browse_session_id = globalCatalogBrowseSessionId

  return {
    event: 'user.click_filter_option',
    extra,
  }
}
